<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="105">
                    <h2>ईज़ी कलेक्ट</h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id="105">
                    
                    
                
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/4o9XW0B-JaY?si=g6yaNdmeY1WRniMm"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                
                <!--<div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'5')"
                (mouseout)="showpayment(false,'5')" id="100">
                    <h2>कार्यप्रवाह</h2>
                </div>
                
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')"
                (mouseout)="showpayment(false,'5')" id="100">
                    <img src="./assets/GIF/Creating Pay Button.gif" width="95%" height="95%"
                 alt="" style="border-radius: 10px;">
                 </div>-->
                
                    <!--<div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/WQXx2iZdyPw"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>-->
                
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="53">
                    <h2 >ईज़ी कलेक्ट के मामलों का उपयोग करें </h2>
                </div>
                <div class="col-md-2 col2 "><button class="btn"><img src="./assets/share (5).svg" style="width: 30px;"
                            alt=""></button></div>
                <div class="col-md-12  mt-2">
                    <div class="col-md-12 mt-4">
                      
                        <label for="" class="mt-2" >
                            <h3>डोनेशन </h3>ईज़ी कलेक्ट विभिन्न कारणों से डोनेशन एकत्र करने की
                            प्रक्रिया को सुव्यवस्थित करता है। व्यापारी, जैसे गैर-लाभकारी संगठन या धन
                            उगाहने वाले अभियान, निर्बाध और सुरक्षित दान प्रक्रियाओं को स्थापित करने
                            के लिए ईज़ी कलेक्ट प्रोफ़ाइल का उपयोग कर सकते हैं। यह सुविधा डोनेशन
                            कर्ताओं को ऑनलाइन लेनदेन की सुविधा का लाभ उठाते हुए, बस कुछ ही क्लिक के
                            साथ आसानी से योगदान करने की अनुमति देती है।


                        </label>
                        <label for="" class="mt-4" >
                            <h3>पंजीकरण शुल्क संग्रहण </h3>उन आयोजनों, कार्यशालाओं या सदस्यताओं के
                            लिए जिनके लिए पंजीकरण शुल्क की आवश्यकता होती है, ईज़ी कलेक्ट शुल्क
                            संग्रह प्रक्रिया को सरल बनाता है। व्यापारी विभिन्न प्रकार के पंजीकरणों
                            के लिए अनुकूलित भुगतान संरचनाएं स्थापित कर सकते हैं, जिससे प्रतिभागियों
                            के लिए ऑनलाइन भुगतान करना आसान हो जाएगा। यह न केवल भौतिक भुगतान को
                            संभालने के प्रशासनिक बोझ को कम करता है बल्कि प्रतिभागियों के लिए समग्र
                            पंजीकरण अनुभव को भी बढ़ाता है।
                        </label>
                        <label for="" class="mt-4" >
                            <h3>रियल इस्टेट </h3>रियल इस्टेट उद्योग में, ईज़ी कलेक्ट संपत्ति लेनदेन
                            से संबंधित भुगतान, जैसे डाउन पेमेंट, किराया या रखरखाव शुल्क के संग्रह की
                            सुविधा प्रदान करता है। संपत्ति के मालिक या रियल इस्टेट एजेंसियां
                            किरायेदारों या खरीदारों को भुगतान करने का सुविधाजनक और सुरक्षित तरीका
                            प्रदान करने के लिए इस सुविधा का लाभ उठा सकती हैं।
                        </label>
                        <label for="" class="mt-4" >
                            <h3>बीमा </h3>ईज़ी कलेक्ट के माध्यम से बीमा प्रीमियम और भुगतान को
                            कुशलतापूर्वक प्रबंधित किया जा सकता है। पॉलिसीधारकों को निर्बाध रूप से
                            प्रीमियम का भुगतान करने में सक्षम बनाने के लिए बीमा कंपनियां इस सुविधा
                            को अपने ऑनलाइन प्लेटफॉर्म में एकीकृत कर सकती हैं। इससे भुगतान में देरी
                            की संभावना कम हो जाती है और यह सुनिश्चित होता है कि नीतियां सक्रिय रहें।
                        </label>
                    </div>
                    <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')"
                        (mouseout)="showpayment(false,'3')" id="54">
                        <h2 >एक आसान कलेक्ट प्रोफ़ाइल कैसे बनाएं: </h2>
                        <label for="" class="mt-4" ><b>चरण 1:</b> पे जी खाते के लिए साइन
                            अप करें। यदि आपके पास पहले से ही एक खाता है, तो अपने क्रेडेंशियल्स के
                            साथ लॉग इन करें।

                            <br><b>चरण 2:</b> पे प्रोफाइल अनुभाग पर जाएं और एक नई प्रोफ़ाइल बनाएं।

                            <br><b>चरण 3:</b> व्यवसाय विवरण और भुगतान विवरण भरें

                            <br><b>चरण 4:</b> भुगतान रसीद सेटिंग्स कॉन्फ़िगर करें।

                            <br><b>चरण 5:</b> वेतन प्रोफ़ाइल कॉन्फ़िगरेशन समायोजित करें।

                            <br><b>चरण 6:</b> अपनी प्रोफ़ाइल अपने ग्राहकों के साथ साझा करें और
                            भुगतान स्वीकार करना शुरू करें। </label>
                    </div>
                    <div class="col-md-12 mt-4">
                        <h3 >अपने पे जी खाते में साइन इन करें| </h3>
                    </div>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/login.png" width="100%" height="80%" alt="">
                        </div>
                    </div>
                    <div class="col-md-12 mt-4">
                     
                        <label for="" class="mt-4">
                            <h3 >डैशबोर्ड के बाईं ओर, "Pay Profile" का विकल्प होगा, उस
                                पर क्लिक करें और आपका पे प्रोफाइल डैशबोर्ड खुल जाएगा। </h3>

                        </label>
                        <div class="row mt-4">
                            <img src="./assets/dashboard.png" alt="" width="80%" height="80%">
                        </div>
                    </div>
                    <div class="col-md-12 mt-4">
                       
                        <label for="" >पे प्रोफाइल डैशबोर्ड के दाईं ओर, " Create New
                            Pay Profile" पर क्लिक करें। </label>
                        <img src="./assets/easy3.png" alt="" class="row mt-4" width="100%"
                            height="80%">
                    </div>
                    <div class="col-md-12 mt-4">
                        
                        <label for="" >दो विकल्पों "Smart Collect" या "Easy Collect"
                            में से "Easy Collect" चुनें। </label>
                        <img src="./assets/easy4.png" alt="" width="100%" height="80%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                       
                        <label for="" >अगले चरण में, अपना इच्छित टेम्पलेट चुनें।
                            "Custom Field" में, आप अपनी आवश्यकताओं के अनुसार अपना स्वयं का टेम्पलेट
                            बना सकते हैं। यह पूरी तरह से अनुकूलन योग्य है| </label>
                        <img src="./assets/easy5.png" alt="" width="80%" height="80%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                      
                        <label for="" >अपनी कंपनी की ब्रांडिंग के अनुसार एक टेम्पलेट
                            रंग चुनें और फिर पहले चरण, "Setup Profile" में सभी आवश्यक विवरण भरें। आप
                            इस क्षेत्र में जितनी आवश्यकता हो उतने फ़ील्ड जोड़ सकते हैं। </label>
                        <img src="./assets/easy6.png" alt="" width="50%" height="40%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                        
                        <label for="" >अपने व्यवसाय विवरण में फ़ील्ड शामिल करने और अपनी
                            कंपनी या संगठन की आवश्यकताओं के अनुसार नियम और शर्तें जोड़ने के लिए "Add
                            Field" पर क्लिक करें </label>
                        <img src="./assets/easy7.png" alt="" width="50%" height="40%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                       
                        <label for="" >अगले चरण, "Payment Receipt" पर आगे बढ़ते हुए, आप
                            अपनी आवश्यकता और ग्राहकों से आपको कितनी जानकारी की आवश्यकता है, उसके
                            आधार पर एक इनपुट प्रकार का चयन करके फ़ील्ड शामिल कर सकते हैं। आपके
                            ग्राहक ये फ़ील्ड देखेंगे, और उन्हें अपना विवरण भरना होगा।

                            उदाहरण के लिए, आपको अपने ग्राहकों का नाम, ईमेल आईडी, मोबाइल नंबर, जन्म
                            तिथि और लिंग लेने की आवश्यकता है ताकि आप इनपुट फ़ील्ड के रूप में क्रमशः
                            टेक्स्ट फ़ील्ड, ईमेल, मोबाइल नंबर, दिनांक पिकर और रेडियो बटन का चयन कर
                            सकें। और आप अपनी आवश्यकता के अनुसार फ़ील्ड को अनिवार्य या नहीं रख सकते
                            हैं। </label>
                        <img src="./assets/easy8.png" alt="" width="50%" height="40%" class="mt-4">
                        <br><img src="./assets/easy9.png" alt="" width="50%" height="40%"
                            class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                        
                        <label for="" >फ़ील्ड बनाने के बाद यह इस तरह दिखेगा|
                        </label><br>
                        <img src="./assets/easy10.png" alt="" width="50%" height="40%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                        
                        <label for="" >फिर " Amount Type " चुनें, आप कैसे भुगतान एकत्र
                            करना चाहते हैं।
                        </label>
                        <img src="./assets/easy11.png" alt="" width="50%" height="40%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                       
                        <label for="" ><b>निश्चित राशि:</b>यदि आप ग्राहक को राशि चुनने
                            का विकल्प दिए बिना किसी उत्पाद की कीमत निर्धारित करना चाहते हैं, तो इस
                            विकल्प का चयन करें। उदाहरण के लिए, एक कार्यक्रम आयोजक के रूप में, यदि आप
                            ₹100 प्रत्येक की निश्चित कीमत पर टिकट बेच रहे हैं और चाहते हैं कि ग्राहक
                            उस विशिष्ट राशि का भुगतान करें, तो आप निश्चित मूल्य विकल्प चुनेंगे।

                        </label>
                        <label for="" class="mt-4" ><b>कैटलॉग बनाएं:</b> विभिन्न चीजों
                            के लिए दान एकत्र करने के लिए एक कैटलॉग बनाएं

                        </label>
                        <label for="" class="mt-4" ><b>एक पदानुक्रमित कैटलॉग
                                बनाएं:</b>इसका उपयोग तब किया जाता है जब आप इन्वेंट्री और विभिन्न
                            श्रेणियां जोड़ना चाहते हैं।

                        </label>
                        <label for="" class="mt-4" ><b>उपयोगकर्ता राशि तय करता है:</b> 
                            यह सुविधा आपके ग्राहकों को उत्पाद या सेवा के लिए राशि चुनने की अनुमति
                            देती है। उदाहरण के लिए, इसका उपयोग दान या इसी तरह के परिदृश्यों के लिए
                            किया जा सकता है।
                        </label>
                        <img src="./assets/easy12.png" alt="" width="50%" height="40%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                        
                        <label for="" >यह आपके ग्राहकों को इस प्रकार दिखाया जाएगा:
                        </label><br>
                        <img src="./assets/easy13.png" alt="" width="50%" height="40%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                        
                        <label for="" >अगला चरण "Payment Receipt Settings" है। अपनी
                            आवश्यकता के अनुसार चयन करें और अगले चरण पर जाएँ।   </label>
                        <img src="./assets/easy14.png" alt="" width="50%" height="40%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                      
                        <label for="" >"Pay Profile Settings" अनुभाग में, आपके पास एक
                            कस्टम यूआरएल सेट करने के विकल्प हैं। आप यूआरएल को वैयक्तिकृत कर सकते हैं
                            या " Generate RAndom Profile URL" का चयन करके यादृच्छिक रूप से जेनरेट
                            किए गए यूआरएल का विकल्प चुन सकते हैं। इसके अतिरिक्त, आप अपने ग्राहकों के
                            लिए आंशिक भुगतान सक्षम कर सकते हैं। आपकी प्रोफ़ाइल कब सक्रिय होनी चाहिए
                            इसके लिए दिनांक और समय निर्धारित करें। आपके पास अपनी प्रोफ़ाइल के लिए एक
                            बटन और एक क्यूआर कोड शामिल करने का विकल्प है। अपनी प्राथमिकताएँ चुनें और
                            फिर अपनी प्रोफ़ाइल बनाने के लिए "Next" बटन पर क्लिक करें।   </label>
                        <img src="./assets/easy15.png" alt="" width="50%" height="40%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                        
                        <label for="" >आप लिंक को कॉपी कर सकते हैं और अपने ग्राहकों को
                            भेजने के लिए क्यूआर कोड डाउनलोड कर सकते हैं। इसके अतिरिक्त, आप इसे अपने
                            ग्राहकों के साथ उनके मोबाइल नंबर या ईमेल पर साझा कर सकते हैं| </label>
                        <img src="./assets/easy16.png" alt="" width="50%" height="40%"
                            class="mt-4"><br>
                        <img src="./assets/easy17.png" alt="" width="50%" height="40%" class="mt-4">
                    </div>
                    <div class="col-md-12 mt-4">
                     
                        <label for="" >अपनी प्रोफ़ाइल बनाने के बाद, आपको अपने डैशबोर्ड
                            पर निर्देशित किया जाएगा जहां आप अपने द्वारा अभी बनाई गई प्रोफ़ाइल देख
                            सकते हैं। आप प्रोफ़ाइल की स्थिति, आपके द्वारा बनाई गई प्रोफ़ाइल की कुल
                            संख्या, आपकी प्रोफ़ाइल को मिले दृश्यों की संख्या और उत्पन्न कुल राजस्व
                            की जांच कर सकते हैं </label>
                        <img src="./assets/easy18.png" alt="" width="100%" height="80%"
                            class="mt-4">
                    </div>

                </div>

            </div>
        </div>
   </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    
                    <h5 >
                        विषयसूची :
                    </h5>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#105" >
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="pdfHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    आसान संग्रह क्या है? </span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                <!--<div class="col-md-12 mt-3">
                    <a href="#100">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/GIF/GIF.svg" class="tab-icon intro"
                                    alt="">
                                </div>
                            <div class="col-md-10 mt-1">
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                                    >
                                    कार्यप्रवाह </span>
                            </div>
                        </div>
                    </a>
                </div>-->

                <div class="col-md-12 mt-3">
                    <a href="#53">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >
                                    ईज़ी कलेक्ट के मामलों का उपयोग करें </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#54">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    >
                                    एक आसान कलेक्ट प्रोफ़ाइल कैसे बनाएं </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="https://payg.in/customer/#/pay-profile/paygfoundation" target="_blank">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                              
                                <span style="cursor: pointer;" class="textHover2"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >
                                    डोनेशन के लिए डेमो प्रोफ़ाइल</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="https://payg.in/customer/#/pay-profile/MTcwMjA3MTk4OQ" target="_blank">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                               
                                <span style="cursor: pointer;" class="textHover2"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >
                                    रियल एस्टेट के लिए डेमो प्रोफ़ाइल</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="https://payg.in/customer/#/pay-profile/MTcwODA4OTg1MQ" target="_blank">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover2"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >
                                    बीमा एकत्रित करने के लिए डेमो प्रोफ़ाइल</span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="https://payg.in/customer/#/pay-profile/MTcwODM4MTI2NA" target="_blank">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover2"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >
                                    सेमिनार पंजीकरण के लिए डेमो प्रोफ़ाइल</span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/Hindi Pay Profile(Easy Collect) new.pdf"
                                target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    ईज़ी कलेक्ट </span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/Hindi Pay Profile(Easy Collect) new.pdf" download><img src="./assets/Download.svg"
                                    alt="" width="100%"></a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
               
                <a [routerLink]="['/pay-profile']">   <button class="btn btn-color" (click)="menues('Pay Profile')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;पे प्रोफाईल

                </button></a>
            </div>
            <div class="col-md-4    ">
                
                <a [routerLink]="['/smart-collect']">  <button class="btn btn-color" (click)="menues('smart collect')"
                    >स्मार्ट
                    कलेक्ट
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>

        </div>
    </div>
    </div>